import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "menu-class test"
};
const _hoisted_2 = ["href"];
import { reactive, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import SubMenus from './SubMenus.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Menus',
  props: {
    mode: {
      default: 'horizontal'
    },
    menuLists: {}
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      activeRoute: ''
    });
    onMounted(() => {
      if (route.path.includes('successCase')) {
        state.activeRoute = '/successCase';
      } else {
        state.activeRoute = route.path;
      }
      console.log(props.menuLists);
    });
    const handleMenuClick = (key, keyPath) => {
      router.push({
        path: key
      });
    };
    watch(() => route.path, val => {
      if (val.includes('successCase')) {
        state.activeRoute = '/successCase';
      } else {
        state.activeRoute = val;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": state.activeRoute,
        mode: props.mode,
        "text-color": "#1b1b1b",
        "active-text-color": "#FF282D",
        onSelect: handleMenuClick
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menuLists, menu => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: menu.path
          }, [!menu.children ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [!(menu !== null && menu !== void 0 && menu.link) ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: menu.path
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(menu === null || menu === void 0 ? void 0 : menu.title)), 1)]),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            class: "el-menu-item"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "el-menu-link",
              href: menu === null || menu === void 0 ? void 0 : menu.link,
              target: "_blank"
            }, _toDisplayString(menu === null || menu === void 0 ? void 0 : menu.title), 9, _hoisted_2)]),
            _: 2
          }, 1024))], 64)) : (_openBlock(), _createBlock(SubMenus, {
            key: 1,
            menu: menu
          }, null, 8, ["menu"]))], 64);
        }), 128))]),
        _: 1
      }, 8, ["default-active", "mode"])]);
    };
  }
});